const getCurrentGameMetaData = () => {
  const recommendedGamesElement = document.getElementById('game-detail-meta-data');
  if (recommendedGamesElement) {
    return {
      gameDetailUniverseId: parseInt(recommendedGamesElement.getAttribute('data-universe-id'), 10),
      gameDetailPlaceId: parseInt(recommendedGamesElement.getAttribute('data-place-id'), 10),
      gameDetailPageId: recommendedGamesElement.getAttribute('data-page-id')
    };
  }
  return null;
};

export default {
  getCurrentGameMetaData
};
